function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#155724",
      strokeWidth: 0.5
    },
    d: "M 12 0 C 5.382812 0 0 5.382812 0 12 C 0 18.617188 5.382812 24 12 24 C 18.617188 24 24 18.617188 24 12 C 24 5.382812 18.617188 0 12 0 Z M 12 22.140625 C 6.410156 22.140625 1.859375 17.59375 1.859375 12 C 1.859375 6.40625 6.410156 1.859375 12 1.859375 C 17.59375 1.859375 22.140625 6.40625 22.140625 12 C 22.140625 17.59375 17.589844 22.140625 12 22.140625 Z M 12 22.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#155724",
      strokeWidth: 0.5
    },
    d: "M 17.503906 7.828125 C 17.128906 7.484375 16.539062 7.507812 16.191406 7.890625 L 10.523438 14.132812 L 7.785156 11.347656 C 7.421875 10.980469 6.835938 10.976562 6.46875 11.335938 C 6.101562 11.695312 6.097656 12.285156 6.457031 12.652344 L 9.886719 16.136719 C 10.0625 16.316406 10.300781 16.414062 10.550781 16.414062 C 10.554688 16.414062 10.5625 16.414062 10.566406 16.417969 C 10.824219 16.410156 11.066406 16.300781 11.238281 16.109375 L 17.570312 9.140625 C 17.914062 8.757812 17.886719 8.171875 17.503906 7.828125 Z M 17.503906 7.828125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.d425c13f339d7e1912bb40fb2f29b212.svg";
export { ForwardRef as ReactComponent };